import { Component, Optional, OnInit, ChangeDetectorRef } from '@angular/core';
import { MdDialog, MdDialogRef, MdSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { SnackBarService } from '../../services/snackbar.service';
import { MessageService } from '../../services/messages.service';
import { CanComponentDeactivate } from '../../services/can-deactivate.service';

@Component({
  selector: 'admin-survey',
  templateUrl: './survey.component.html'
})

/**
 * Component for displaying and saving Surveys.
 */
export class SurveyComponent implements OnInit {
  adminSurveyForm: FormGroup;
  savingSurvey = false;

  constructor(private fb: FormBuilder,
    private snackBarService: SnackBarService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.adminSurveyForm = this.fb.group({});
    this.adminSurveyForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged(); // (re)set validation messages now
  }

  openAddSurveyConfigDialog(action: string) {
    alert('In Progress');
    /*let config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddSurveyConfigComponent, config);
    //this.dialogRef.componentInstance.selectedCountry = this.selectedCountry;
    this.dialogRef.componentInstance.action = action;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      //this.selectedCountry = {};
      if (result) {
        //this.updateCountryList(result);
      }
    });*/
  }

  onValueChanged(data?: any) {
    if (!this.adminSurveyForm) {
      return;
    }
    const form = this.adminSurveyForm;
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/survey/survey.component.ts